import React, {useContext} from 'react';
import IconBase from './IconBase';
import {BrandContext} from "@context/BrandContext";

const WidgetActivityIcon = props => {
    const brandConfig = useContext(BrandContext);
    return (
        <IconBase {...props} defaultTooltipTitle={brandConfig.widgetName} useTag={'<use xlink:href="#widget-icon"/>'} viewBox={'0 0 128 128'}>
        </IconBase>
    )
}

export default WidgetActivityIcon;